import { Sizes } from "types/styles";

const getSizeStr = (size: Sizes, type: "px" | undefined = "px"): string => {
  return `${size}${type}`;
};

export default getSizeStr;
